var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66668 23.3334C4.02501 23.3334 3.4759 23.1051 3.01934 22.6486C2.56279 22.192 2.33412 21.6425 2.33334 21.0001V7.00008C2.33334 6.35841 2.56201 5.8093 3.01934 5.35275C3.47668 4.89619 4.02579 4.66753 4.66668 4.66675H23.3333C23.975 4.66675 24.5245 4.89541 24.9818 5.35275C25.4392 5.81008 25.6675 6.35919 25.6667 7.00008V21.0001C25.6667 21.6417 25.4384 22.1912 24.9818 22.6486C24.5253 23.1059 23.9758 23.3342 23.3333 23.3334H4.66668ZM14 15.1667L23.3333 9.33341V7.00008L14 12.8334L4.66668 7.00008V9.33341L14 15.1667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.8b179367243e247f56936e0c2cdc6d93.svg";
export { ForwardRef as ReactComponent };